import React, { useEffect } from 'react'
import { Product, ProductButton } from '../components/Product'
import { RouteComponentProps } from 'react-router'
import { Mainlink } from '../components/Mainlink'
import { Introduction } from '../components/Introduction'
import path from 'path'
import { useSelector } from 'react-redux'
import { AppState } from '../store'
import { GlobalMaterialFolderItem } from '../store/category/reducers'

type UrlParams = {
  category: string
}

const getGridClasses = (amount: number) => {
  switch (amount) {
    case 1:
      return 'grid-span4 grid-shift4 grid-desktop-span6 grid-desktop-shift3 grid-tablet-span8 grid-tablet-shift2 grid-mobile-span12 grid-mobile-shift0'
    case 3:
      return 'grid-span4 grid-omega3 grid-mobile-span12 grid-text-center grid-laptop-gap3-below'
    default:
      return 'grid-span3 grid-laptop-span6 grid-laptop-omega2 grid-mobile-span12 grid-text-center grid-laptop-gap3-below'
  }
}

export const Category: React.FC<RouteComponentProps<UrlParams>> = (props) => {
  const { category: tag } = props.match.params
  const categories = useSelector((p: AppState) => p.categoriesReducer.categories)
  const items = Object.entries(categories).reduce<GlobalMaterialFolderItem[]>((acc, [title, c]) => {
    return [...acc, ...c.filter((i) => i.categoryId === tag)]
  }, [])

  // this is a bit ugly, and smells a bit, but I think it's the best way of integrating with the current codebase
  useEffect(() => {
    // window.initializeChosen()

    window.$('.equalheight-group1').matchHeight({
      property: 'min-height'
    })
  }, [])

  return (
    <>
      <div className="grid-outer-container">
        <div className="grid-row grid-gap2-below">
          <div className="grid-span12 grid-text-center">
            <Mainlink to="/">{window.translations['Material - Back to overview']}</Mainlink>
          </div>
        </div>
      </div>

      {items.length === 0 ? (
        <div className="grid-outer-container grid-gap6-above">
          <div className="grid-row">
            <h3 className="grid-text-center">Not found</h3>
          </div>
        </div>
      ) : (
        <>
          <Introduction title={items[0].categoryTitle} text={items[0].categoryDescription} />

          <div className="grid-outer-container grid-gap6-below grid-laptop-gap0-below">
            <div className="grid-row">
              {items.map((product) => (
                <div key={product.itemId} className={['grid-text-center', getGridClasses(items.length)].join(' ')}>
                  <Product
                    title={product.materialTitle}
                    description={product.materialDescription}
                    backgroundImage={
                      product.materialImage !== null
                        ? product.materialImage
                        : 'https://www.universal-robots.com/media/product2.png'
                    }
                    button={
                      <ProductButton
                        to={path.join(props.match.url, product.itemId)}
                        dangerouslySetInnerHTML={{
                          __html: window.translations['Material - Choose x'].replace(
                            '$item$',
                            product.title.replace(/(UR)(\d+)e/i, '$1$2<span class="helper-nocase">e</span>')
                          )
                        }}
                      />
                    }
                  />
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </>
  )
}
